import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import cn from '../../lib/utils/cn'
import logo1 from '../../../src/assets/images/solarion-logo.png'

interface LogoProps {
	imageOnly?: boolean
	className?: string
}

const Logo: React.FC<LogoProps> = ({ imageOnly, className = '' }) => {
	const styles = {
		logo: {
			height: '36px',
			marginRight: imageOnly ? '0' : '8px',
		},
		logoText: {
			fontWeight: '900' as const,
			marginLeft: '10px',
		},
		navbarLogo: {},
	}

	return (
		<Link
			to="/dashboard"
			style={styles.navbarLogo}
			className={cn('logo-company', className)}
		>
			<motion.img
				layout
				src={logo1}
				style={styles.logo}
				className="logo"
				alt="Solarion.AI"
			/>
			{!imageOnly && (
				<motion.div
					layout
					initial={{ opacity: 0, y: 12 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ delay: 0.125 }}
					className="rainbow-text"
					style={styles.logoText}
				>
					Aura
				</motion.div>
			)}
		</Link>
	)
}

export default Logo
